import axios from "axios";
import { EXPRESS_BASE_URL } from "./apiConfig";

// Bireysel (kurumsal olmayan) kullanicilar icin: kayit formunda veya
// Google ile uye olurken zaten kabul edilmis sayiyoruz, bu yuzden burada
// HICBIR swal/ui gostermiyoruz - sadece ilk girişte arka planda sessizce
// individualmembershipapproval tablosuna bir kayit dusuyoruz (zaten varsa
// hicbir sey yapmiyoruz).
export const ensureIndividualMembershipApproval = async (userInfo) => {
    if (!userInfo) return;

    const isIndividualStudent = userInfo.roleName === "Student" && userInfo.isInvidual === true;
    if (!isIndividualStudent) return;

    try {
        const checkRes = await axios.get(
            `${EXPRESS_BASE_URL}/getindividualmembershipapprovalbyuserid/${userInfo.id}`
        );
        if (Array.isArray(checkRes.data) && checkRes.data.length > 0) return;
    } catch (err) {
        console.error("Bireysel üyelik onay kaydı kontrol edilirken hata oluştu:", err);
        return;
    }

    try {
        await axios.post(`${EXPRESS_BASE_URL}/postindividualmembershipapproval`, {
            userid: userInfo.id,
            name: userInfo.fullName,
            email: userInfo.username,
            type: 0,
            ticariileti: 1,
            kullanimsozlesmesi: 1,
            kvkk: 1,
        });
    } catch (err) {
        console.error("Bireysel üyelik onay kaydı oluşturulamadı:", err);
    }
};
